import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { APIHelperService } from './api-helper.service';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { AuthResponseModel } from '../../pages/login/account.model';
import { SiblingStudent } from '../models/sibling.model';

@Injectable({
  providedIn: 'root',
})
export class SiblingService {
  private readonly siblingsSubject = new BehaviorSubject<SiblingStudent[]>([]);
  readonly siblings$ = this.siblingsSubject.asObservable();

  private httpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private apiHelperService: APIHelperService,
    private authService: AuthService
  ) {}

  get hasMultipleChildren(): boolean {
    return this.siblingsSubject.value.length > 1;
  }

  get currentSibling(): SiblingStudent | undefined {
    return this.siblingsSubject.value.find((s) => s.is_current);
  }

  loadSiblings(): Observable<SiblingStudent[]> {
    return new Observable((observer) => {
      this.apiHelperService
        .get(`${environment.apiURI}/student/siblings`, this.httpHeaders)
        .subscribe({
          next: (response: { data?: SiblingStudent[] }) => {
            const list = Array.isArray(response?.data) ? response.data : [];
            this.siblingsSubject.next(list);
            observer.next(list);
            observer.complete();
          },
          error: (err) => {
            this.siblingsSubject.next([]);
            observer.error(err);
          },
        });
    });
  }

  switchSibling(studentId: number): Observable<AuthResponseModel> {
    return new Observable((observer) => {
      this.apiHelperService
        .post(
          `${environment.apiURI}/student/switch/${studentId}`,
          {},
          this.httpHeaders
        )
        .subscribe({
          next: (authResponse: AuthResponseModel) => {
            this.authService.saveAuthResponse(authResponse);
            if (authResponse.profile_image) {
              localStorage.setItem('profile_image', authResponse.profile_image);
            } else {
              localStorage.removeItem('profile_image');
            }
            observer.next(authResponse);
            observer.complete();
          },
          error: (err) => observer.error(err),
        });
    });
  }

  clear(): void {
    this.siblingsSubject.next([]);
  }
}
